import React from 'react';
import { LoadingMedium } from './LoadingMedium';

type LoadingScreenProps = {
  className?: string;
};

export const LoadingScreen: React.FC<LoadingScreenProps> = ({
  className = ""
}) => {
  return (
    <div className={`fixed inset-0 bg-white flex items-center justify-center z-50 ${className}`}>
      <div className="flex flex-col items-center justify-center space-y-6">
        {/* Pulsing circles animation */}
        <LoadingMedium />
      </div>
    </div>
  );
};
